import React, { Fragment, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Col, Form, Row } from 'react-bootstrap';
import { Card, CardBody } from 'reactstrap';
import { useMutation } from 'react-query';
import { FormDataFeild } from '../reuseable/Inputs';
import { IsLoadingResponse, ToastMessage } from '../utils/Helper';
import { TYPE_FELDS, Submit } from '../constants';
import { resetPasswordSchema } from '../utils/validationSchema';
import { Put_Reset_Password } from '../Apis/userApi/UserApi';

const ResetPasswordPopup = ({ dialog, setdialogs, userId, userName }) => {
   const [formData, setFormData] = useState({
      password: '',
      confirmPassword: ''
   });
   const [errors, setErrors] = useState({});

   const { mutate: resetPassword, isLoading } = useMutation(
      (data) => Put_Reset_Password(data),
      {
         onSuccess: (response) => {
            if (response && response.status === 200) {
               ToastMessage(response.status, response.data.message || 'Password reset successfully');
               setdialogs(false);
               setFormData({
                  password: '',
                  confirmPassword: ''
               });
               setErrors({});
            }
         }
      }
   );

   const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({
         ...prev,
         [name]: value
      }));
   };

   const handleSubmit = async (e) => {
      e.preventDefault();
      try {
         const schema = resetPasswordSchema();
         await schema.validate(formData, { abortEarly: false });
         setErrors({});
         resetPassword({
            userId: userId,
            password: formData.password,
            confirmPassword: formData.confirmPassword
         });
      } catch (err) {
         const validationErrors = {};
         if (err.inner) {
            err.inner.forEach((validationError) => {
               validationErrors[validationError.path] = validationError.message;
            });
            setErrors(validationErrors);

            const firstErrorKey = Object.keys(validationErrors)[0];
            if (firstErrorKey) {
               const inputField = document.getElementsByName(firstErrorKey);
               if (inputField && inputField[0]) {
                  inputField[0].focus();
               }
            }
         }
      }
   };

   const handleClose = () => {
      setdialogs(false);
      setFormData({
         password: '',
         confirmPassword: ''
      });
      setErrors({});
   };

   return (
      <Fragment>
         <Dialog
            header={`Reset Password - ${userName || ''}`}
            className="modal_style"
            visible={dialog}
            position="top"
            onHide={handleClose}
            draggable={false}
            resizable={false}
            style={{ width: '400px' }}
         >
            <IsLoadingResponse isLoading={isLoading} />
            <Row>
               <Col sm="12">
                  <Card>
                     <CardBody>
                        <Form className="needs-validation" onSubmit={handleSubmit}>
                           <Row>
                              <Col md="12" className="mb-4">
                                 <FormDataFeild
                                    label="New Password *"
                                    name="password"
                                    id="password"
                                    type={TYPE_FELDS.password}
                                    placeholder="New Password"
                                    value={formData.password}
                                    handleChange={handleChange}
                                 />
                                 {errors.password && (
                                    <span className="error-validation">{errors.password}</span>
                                 )}
                              </Col>
                              <Col md="12" className="mb-4">
                                 <FormDataFeild
                                    label="Confirm Password *"
                                    name="confirmPassword"
                                    id="confirmPassword"
                                    type={TYPE_FELDS.password}
                                    placeholder="Confirm Password"
                                    value={formData.confirmPassword}
                                    handleChange={handleChange}
                                 />
                                 {errors.confirmPassword && (
                                    <span className="error-validation">{errors.confirmPassword}</span>
                                 )}
                              </Col>
                           </Row>
                           <Row>
                              <Col md="12" className="btn-style d-flex justify-content-end">
                                 <Button
                                    label={Submit}
                                    icon="pi pi-check"
                                    loading={isLoading}
                                    type={TYPE_FELDS.submit}
                                 />
                              </Col>
                           </Row>
                        </Form>
                     </CardBody>
                  </Card>
               </Col>
            </Row>
         </Dialog>
      </Fragment>
   );
};

export default ResetPasswordPopup;
